export enum SuppliesDiscountMethod {
  Code = "code",
}
